import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Box, Paper, Avatar, Link } from '@mui/material';
import { fCurrency } from '../../../../utils/formatNumber';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 24,
  border: '1px solid #F1F5F9',
  boxShadow: 'none',
  background: '#FFF',
}));

const TransactionItem = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  borderBottom: '1px solid #F8FAFC',
  '&:last-child': {
    borderBottom: 'none',
  }
}));

// ----------------------------------------------------------------------

YangaRecentTransactions.propTypes = {
  transactions: PropTypes.array,
  onViewAll: PropTypes.func,
};

export default function YangaRecentTransactions({ transactions, onViewAll }) {
  return (
    <RootStyle>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>Recent Transactions</Typography>
        <Link onClick={onViewAll} sx={{ cursor: 'pointer', color: 'primary.main', fontWeight: 700, textDecoration: 'none', fontSize: '0.875rem' }}>
          View All
        </Link>
      </Stack>

      {transactions && transactions.length > 0 ? (
        transactions.map((tx, index) => (
          <TransactionItem key={index} direction="row" spacing={2} alignItems="center">
            <Avatar sx={{ 
                bgcolor: tx.type === 'credit' ? '#ECFDF5' : '#FEF2F2',
                color: tx.type === 'credit' ? '#10B981' : '#EF4444',
                width: 44,
                height: 44,
                borderRadius: 1.5
            }}>
               <Iconify icon={tx.type === 'credit' ? 'eva:arrow-downward-fill' : 'eva:arrow-upward-fill'} width={20} height={20} />
            </Avatar>
            
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '0.9rem' }}>{tx.description}</Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>{tx.date}</Typography>
            </Box>

            <Box sx={{ textAlign: 'right', minWidth: 80 }}>
               <Typography variant="subtitle2" sx={{ 
                 fontWeight: 800, 
                 color: tx.type === 'credit' ? '#10B981' : '#111827',
                 whiteSpace: 'nowrap'
               }}>
                 {tx.type === 'credit' ? '+' : '-'}{fCurrency(tx.amount)}
               </Typography>
               <Typography variant="caption" sx={{ 
                 fontWeight: 600,
                 color: tx.status === 'success' ? 'success.main' : 'warning.main',
                 textTransform: 'capitalize'
               }}>
                 {tx.status}
               </Typography>
            </Box>
          </TransactionItem>
        ))
      ) : (
        <Stack alignItems="center" justifyContent="center" sx={{ py: 4, opacity: 0.4 }}>
           <Iconify icon="eva:list-outline" width={40} height={40} />
           <Typography variant="body2" sx={{ mt: 1 }}>No transactions yet</Typography>
        </Stack>
      )}
    </RootStyle>
  );
}
